/**
 * Double-clic sur une variable du canvas → panneau « Variables » ouvert sur
 * elle (parité `VariableDecorator` du classique).
 *
 * Le nœud vit dans un éditeur Tiptap du canvas, le panneau dans `WebEditor` :
 * un registre module-level les relie sans abonner la frappe à quoi que ce soit
 * (invariant §4.3 du README).
 */

/** @type {Set<(key: string) => void>} */
const listeners = new Set();

export function onVariableFocusRequest(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function requestVariableFocus(key) {
  if (!key) return;
  listeners.forEach((listener) => listener(key));
}

/**
 * Double-clic sur une image ou un tableau variable du canvas → onglet
 * Formulaire ouvert sur la box (Image.jsx / Table du classique). Le bloc ne
 * connaît que son id : l'éditeur, qui sait quelle portée est ouverte, en
 * déduit la ligne du formulaire.
 */
/** @type {Set<(blockId: string) => void>} */
const boxListeners = new Set();

export function onBoxFocusRequest(listener) {
  boxListeners.add(listener);
  return () => boxListeners.delete(listener);
}

/** `block` : l'item Puck dont le formulaire doit montrer la première box. */
export function requestBoxFocus(block) {
  if (!block?.props?.id) return;
  boxListeners.forEach((listener) => listener(block));
}
